module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-prez-left-3b25bf65f5b3686ae9b043c13a05e2ab.svg";